import angular from 'angular';
import dialogCloseComponent from './dialog-close.component';

export default angular.module('common.dialogClose', [])
  .component('dialogClose', dialogCloseComponent)
  .name;



// WEBPACK FOOTER //
// ./components/app/common/dialog-close/dialog-close.module.js